import { render } from "./TeacherList.vue?vue&type=template&id=2af9ec9e&scoped=true"
import script from "./TeacherList.vue?vue&type=script&lang=js"
export * from "./TeacherList.vue?vue&type=script&lang=js"

import "./TeacherList.vue?vue&type=style&index=0&id=2af9ec9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af9ec9e"]])

export default __exports__